/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=a8223a32&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=a8223a32&scoped=true&lang=scss"
import "./index.vue?vue&type=style&index=1&id=a8223a32&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8223a32"]])

export default __exports__